import { useEffect } from "react";
import { SITE_URL, LOGO_URL } from "@/data/siteContent";

function setMeta(selector, attr, name, content) {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export function Seo({ title, description, path = "" }) {
  useEffect(() => {
    const canonical = `${SITE_URL}${path}`;
    if (title) document.title = title;
    if (description) setMeta('meta[name="description"]', "name", "description", description);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);

    setMeta('meta[property="og:type"]', "property", "og:type", "website");
    setMeta('meta[property="og:site_name"]', "property", "og:site_name", "AnyTribe Marketing");
    setMeta('meta[property="og:url"]', "property", "og:url", canonical);
    if (title) setMeta('meta[property="og:title"]', "property", "og:title", title);
    if (description)
      setMeta('meta[property="og:description"]', "property", "og:description", description);
    setMeta('meta[property="og:image"]', "property", "og:image", LOGO_URL);
    setMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
    if (title) setMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
    if (description)
      setMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
    setMeta('meta[name="twitter:image"]', "name", "twitter:image", LOGO_URL);
  }, [title, description, path]);

  return null;
}
